const initialState = {
  cache: {},
  statsLoading: false
};

export default initialState;
